import React from "react";

const formatAmount = (value) =>
  `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

const Card = ({ label, value, color }) => (
  <div className="bg-white shadow rounded-xl p-5">
    <p className="text-gray-500">{label}</p>
    <h2 className={`text-2xl font-bold ${color}`}>{value}</h2>
  </div>
);

// Figures for the rows currently listed, once the list has been narrowed down
export const PaymentSelectionCards = ({ rows }) => {
  const sum = (list) =>
    list.reduce((total, row) => total + Number(row.amount || 0), 0);
  const isCredit = (row) => row.type?.toLowerCase() === "credit";

  const credits = rows.filter(isCredit);
  const debits = rows.filter((row) => !isCredit(row));
  const due = rows.filter((row) => row.isPaymentDue);
  const isMixed = credits.length > 0 && debits.length > 0;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {isMixed ? (
        <>
          <Card
            label="Credit"
            value={formatAmount(sum(credits))}
            color="text-green-600"
          />
          <Card
            label="Debit"
            value={formatAmount(sum(debits))}
            color="text-red-600"
          />
        </>
      ) : (
        <>
          <Card
            label="Total"
            value={formatAmount(sum(rows))}
            color="text-blue-600"
          />
          <Card
            label="Paid"
            value={formatAmount(sum(rows.filter((row) => !row.isPaymentDue)))}
            color="text-green-600"
          />
        </>
      )}
      <Card label="Due" value={formatAmount(sum(due))} color="text-amber-600" />
      <Card label="Entries" value={rows.length} color="text-gray-800" />
    </div>
  );
};

const PaymentSummaryCards = ({ totals }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6">
      <Card
        label="Total Balance"
        value={formatAmount(totals.total)}
        color="text-blue-600"
      />
      <Card
        label="Total Credit"
        value={formatAmount(totals.credit)}
        color="text-green-600"
      />
      <Card
        label="Total Debit"
        value={formatAmount(totals.debit)}
        color="text-red-600"
      />
    </div>
  );
};

export default PaymentSummaryCards;
